import e from "./index.ce.vue.js";
import { defineAndRegisterElement as t } from "../../utils/register-element.js";
const p = t(e);
export {
  p as initRelatedApproval
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/related-approval/index.js
// module id = 1285
// module chunks = 41